export default __webpack_public_path__ + "ce373cbf90611f125bd2db5811d4b660.png";